import styled from "styled-components";
import { SectionWrapper, TextWrapper } from "shared/Styles/Wrappers";
import { Button } from "components/Buttons";
import DribbleIcon from "assets/images/dribble_2.svg";
import DribbleBg from "assets/images/dribble_bg.svg";

export const Container = styled.div`
  padding: 124px 0;
  background-color: ${({ color }) => (color ? color : "#fff")};
  color: ${({ color }) => (color ? "#fff" : "#000")};
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    padding: 64px 0;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 36px 0;
  }
`;

export const Wrapper = styled(SectionWrapper)``;

export const FormWrapper = styled(TextWrapper)``;

export const FormTitle = styled.h3`
  color: #000;
  font-size: 4rem;
  font-weight: 800;
  max-width: 700px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  margin-bottom: 64px;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    font-size: 3rem;
    margin-bottom: 32px;
    max-width: 560px;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 2.4rem;
    max-width: 400px;
  }
  @media screen and (max-width: 500px) {
    max-width: 100%;
    font-size: 2rem;
  }
`;

export const FormInfo = styled.div`
  width: 100%;
  text-align: center;
  font-size: 3rem;
  font-weight: 800;
  margin: 64px 0;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    font-size: 2rem;
    margin: 32px 0;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
  }
`;

export const DribbleContainer = styled.div`
  background-color: #ea4c89;
  background-image: url(${DribbleBg});
  background-repeat: no-repeat;
  background-position: top right;
  background-size: auto 100%;
  width: 100%;
  border-radius: 5px;
  color: #fff;
  padding: 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    padding: 36px;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 24px;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone_big}) {
    flex-direction: column;
    padding: 36px 12px 36px 12px;
    background-image: none;
    margin: 48px 0;
  }
`;

export const DribbleText = styled.div`
  position: relative;
  padding-left: 90px;
  &:before {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    width: 60px;
    height: 60px;
    background-image: url(${DribbleIcon});
    background-repeat: no-repeat;
    background-size: contain;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    padding-left: 74px;
    &:before {
      width: 48px;
      height: 48px;
    }
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding-left: 56px;
    &:before {
      width: 32px;
      height: 32px;
    }
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone_big}) {
    padding-left: 0;
    padding-top: 64px;
    text-align: center;
    &:before {
      top: 0%;
      left: 50%;
      width: 48px;
      height: 48px;
      transform: translate(-50%, 0);
    }
  }
`;

export const Title = styled.div`
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 8px;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    font-size: 2.4rem;
    margin-bottom: 4px;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 1.8rem;
    margin-bottom: 4px;
  }
`;

export const Text = styled.div`
  font-size: 1.6rem;
  font-weight: 400;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    font-size: 1.4rem;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 1.2rem;
  }
`;

export const StyledButton = styled(Button)`
  background-color: #fff;
  color: #000;
  &:hover {
    background-color: #000;
    color: #fff;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone_big}) {
    margin-top: 36px;
  }
`;
